<template>
  <Popover
    ref="popover"
    trigger="hover"
    :stay-on-click="true"
    popover-class="popover-default status-popover"
    :bound-to="{ x: 'container' }"
    :offset="offset"
    @show="enter"
  >
    <template #trigger>
      <slot />
    </template>
    <template #content>
      <!-- a click anywhere opens the post (a mouse shortcut; the post's
           time link does it for keyboards) -->
      <div
        v-if="status"
        class="status-preview-link"
        role="link"
        @click="open"
        @auxclick="open"
      >
        <Status
          :is-preview="true"
          :status-id="statusId"
          :compact="true"
          :ignore-mute="true"
        />
      </div>
      <div
        v-else-if="error"
        class="status-preview-no-content faint"
      >
        {{ $t('status.status_unavailable') }}
      </div>
      <div
        v-else
        class="status-preview-no-content"
      >
        <FAIcon
          icon="circle-notch"
          spin
          size="2x"
        />
      </div>
    </template>
  </Popover>
</template>

<script src="./status_popover.js"></script>

<style lang="scss">
/* popover styles load on-demand, so we need to override */
.status-popover.popover {
  font-size: 1rem;
  min-width: 15em;
  max-width: 95%;
  border-color: var(--border);
  border-style: solid;
  border-width: 1px;

  /* TODO cleanup this */
  .Status.Status {
    border: none;
  }

  .status-preview-link {
    cursor: pointer;
  }

  .status-preview-no-content {
    padding: 1em;
    text-align: center;

    i {
      font-size: 2em;
    }
  }
}

</style>
